module.exports = __webpack_public_path__ + "img/usericon.6b42ecba.png";